import { render } from "./FinancialCategories.vue?vue&type=template&id=2c807418&scoped=true"
import script from "./FinancialCategories.vue?vue&type=script&lang=js"
export * from "./FinancialCategories.vue?vue&type=script&lang=js"

import "./FinancialCategories.vue?vue&type=style&index=0&id=2c807418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c807418"]])

export default __exports__